export default "__VITE_ASSET__DkALx$sM__"